module.exports = __webpack_public_path__ + "img/shop-remove.171f5a3c.svg";